import type { MatDialogConfig } from '@angular/material/dialog';
import { TConfirmationModalData } from '@dss-libs/shared/type/common-types';

const API_SETTINGS = 'SETTINGS.API_SETTINGS';

export const API_KEY_CONFIRMATION_MODAL_DIMENSIONS: MatDialogConfig = { width: '28.75rem' };
export const API_KEY_MODAL_DIMENSIONS: MatDialogConfig = { width: '35rem' };
export const API_KEY_REVEAL_MODAL_DIMENSIONS: MatDialogConfig = { width: '35rem', disableClose: true };

export const ROTATE_API_KEY_CONFIRMATION: TConfirmationModalData = {
  svgIcon: 'danger-triangle-outline',
  iconVariant: 'warning',
  title: `${API_SETTINGS}.ROTATE_MODAL.TITLE`,
  subtitle: `${API_SETTINGS}.ROTATE_MODAL.SUBTITLE`,
  message: `${API_SETTINGS}.ROTATE_MODAL.MESSAGE`,
  callout: `${API_SETTINGS}.ROTATE_MODAL.CALLOUT`,
  primaryButtonLabel: `${API_SETTINGS}.ROTATE_MODAL.CONFIRM`,
};

export const DISABLE_API_KEY_CONFIRMATION: TConfirmationModalData = {
  svgIcon: 'danger-triangle-outline',
  iconVariant: 'warning',
  title: `${API_SETTINGS}.DISABLE_MODAL.TITLE`,
  subtitle: `${API_SETTINGS}.DISABLE_MODAL.SUBTITLE`,
  message: `${API_SETTINGS}.DISABLE_MODAL.MESSAGE`,
  callout: `${API_SETTINGS}.DISABLE_MODAL.CALLOUT`,
  primaryButtonLabel: `${API_SETTINGS}.DISABLE_MODAL.CONFIRM`,
};

export const ACTIVATE_API_KEY_CONFIRMATION: TConfirmationModalData = {
  svgIcon: 'danger-triangle-outline',
  iconVariant: 'warning',
  title: `${API_SETTINGS}.ACTIVATE_MODAL.TITLE`,
  subtitle: `${API_SETTINGS}.ACTIVATE_MODAL.SUBTITLE`,
  message: `${API_SETTINGS}.ACTIVATE_MODAL.MESSAGE`,
  callout: `${API_SETTINGS}.ACTIVATE_MODAL.CALLOUT`,
  primaryButtonLabel: `${API_SETTINGS}.ACTIVATE_MODAL.CONFIRM`,
};

export const DELETE_API_KEY_CONFIRMATION: TConfirmationModalData = {
  svgIcon: 'trash-bin-trash-outline',
  iconVariant: 'danger',
  calloutVariant: 'danger',
  title: `${API_SETTINGS}.DELETE_MODAL.TITLE`,
  subtitle: `${API_SETTINGS}.DELETE_MODAL.SUBTITLE`,
  message: `${API_SETTINGS}.DELETE_MODAL.MESSAGE`,
  callout: `${API_SETTINGS}.DELETE_MODAL.CALLOUT`,
  primaryButtonLabel: `${API_SETTINGS}.DELETE_MODAL.CONFIRM`,
  primaryButtonColor: 'danger',
};
